export default __webpack_public_path__ + "static/media/testimonials-bg.a0a3b884.webp";